import axios from "axios";

// ✅ create axios instance
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:5000/api",
  withCredentials: true, // allow cookies
  headers: {
    "Content-Type": "application/json",
  },
});

// ✅ request interceptor (add token)
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ response interceptor (handle auth error)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.replace("/login"); // safer redirect
    }
    return Promise.reject(error);
  }
);

export default api;
